import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import {
  updateVisitDetail,
  getPatientVisitDetails,
} from "../../actions/patientActions";

const UpdateLocationTagConfirmModal = ({
  show,
  handleClose,
  token,
  visitDetailId,
  parentVisitId,
  selectedTag,
  onUpdated,
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleConfirm = () => {
    if (!selectedTag) {
      toast.error("Please select a location tag");
      return;
    }
    setLoading(true);
    dispatch(
      updateVisitDetail(token, visitDetailId, { location_tag: selectedTag })
    )
      .then(() => {
        toast.success("Location tag updated");
        // Refresh visit details so UI reflects backend
        return dispatch(getPatientVisitDetails(token, parentVisitId));
      })
      .then(() => {
        onUpdated && onUpdated();
        setLoading(false);
        handleClose();
      })
      .catch(() => {
        setLoading(false);
        toast.error("Failed to update location tag");
      });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter">
            Location Tag Update Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to set the location tag to "{selectedTag}"?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="success" onClick={handleConfirm} disabled={loading}>
            {loading ? "Updating..." : "Confirm"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdateLocationTagConfirmModal;
